import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { use } from 'cytoscape';
import { ListComponent, SearchUser, SearchUsersService } from 'reg-hub-common';

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrl: './search-users.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchUsersComponent extends ListComponent<SearchUser> {
  displayedColumns: string[] = [
    'name',
    'username',
    'email',
    'userGroupName',
    'status'
  ];

  constructor(
    repo: SearchUsersService,
    private router: Router
  ) {
    super(repo);
    this.repo = repo;
  }

  getUserStatus(user: SearchUser):string {
    return user.isActive ? 'ACTIVE' : 'INACTIVE';
  }

  formatName(user: SearchUser):string {
    if (user.middleName) {
      return `${user.firstName} ${user.middleName} ${user.lastName}`
    }
    else {
      return `${user.firstName} ${user.lastName}`
    }
  }
}